export const featureFlags: Features = {
  billingEngine:
    process.env.REACT_APP_BILLING_ENGINE_FEATURE?.toLowerCase() === "true" ||
    process.env.REACT_APP_ENV === "production",
};
